import React from 'react'
import { Link } from 'react-router-dom'

function Template() {
  return (
    <div>
          <div>
      <h1>Go to Template</h1>
      <Link to="../../Email/MembershipTemplate.html">Open Template</Link>
    </div>
    </div>
  )
}

export default Template
